import axios from 'axios';
import store from '@/store';
import keys from '@/store/keys';
import _ from 'lodash';
import {
  EventBus
} from '@/services/eventBus';

export default {
  async getCountryAws(start) {
    try {
      let resp = await axios.get('/whereami');
      let spanishCountries = store.state.spanishCountries;
      if (_.indexOf(spanishCountries, resp.data.country) !== -1) {
        if (resp.data.country === 'CL') {
          store.commit('CHANGE_LANG_SELECTED', {
            langSelected: 'es-CL',
            init: false
          });
        } else {
          store.commit('CHANGE_LANG_SELECTED', {
            langSelected: 'es-ES',
            init: false
          });
        }
      } else {
        store.commit('CHANGE_LANG_SELECTED', {
          langSelected: 'en-GB',
          init: false
        });
      }
      start();
    } catch (error) {}
  },
  changeLanguage(country) {
    let locale = 'en-GB';

    if (country === 'ca') {
      locale = 'ca-ES';
    } else if (country === 'es') {
      locale = 'es-ES';
    } else if (country === 'cl') {
      locale = 'es-CL';
    }

    setTimeout(() => {
      EventBus.$emit(keys.eventOnInitializeWithLanguage, {
        locale: locale,
        init: true
      });
    }, 250);
  }
};



// WEBPACK FOOTER //
// ./src/services/localeService.js